import React from "react";
import * as actions from '../actions';
import Service from '../../../service/Service';
const service = new Service();

export default function ShareOptions({ eleRef, index }) {
    return (
        <div className="sharing-options dev_shr" id={"share_" + index}>
            <ul className="left">
                <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp', "")}>
                    <span className="M16_61 social-share" id="whatsapp">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </span>
                </li>
                <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook', "")}>
                    <span className="M16_61 social-share" id="facebook">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </span>
                </li>
                <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter', "")}>
                    <span className="M16_61 social-share" id="twitter">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </span>
                </li>
                <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest', "")}>
                    <span className="M16_61 social-share" id="pintrest">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </span>
                </li>
            </ul>
        </div>
    );
}
